/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const Devices = loadable(() => import('./AllDevices'), {
  fallback: <LoadingIndicator />,
});

export const OwnedDevices = loadable(() => import('./OwnedDevices'), {
  fallback: <LoadingIndicator />,
});

export const DeviceDetails = loadable(() => import('./DeviceDetails'), {
  fallback: <LoadingIndicator />,
});

export const DeviceSetting = loadable(() => import('./DeviceSettings'), {
  fallback: <LoadingIndicator />,
});
